var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHeaderMobileScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 557,
    viewBox: "0 0 375 557",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6410_183203)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.112 403.616C273.019 387.19 164.211 355.705 -20.8873 503.545C-205.985 651.384 -51.7653 -1168 -51.7653 -1168L193.235 -1168L460.235 -1168C460.235 -1168 623.204 420.043 448.112 403.616Z",
    fill: "url(#paint0_linear_6410_183203)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6410_183203",
    x: -152,
    y: -1204,
    width: 721.203,
    height: 1760.09,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0784314 0 0 0 0 0.301961 0 0 0 0 0.870588 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6410_183203"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6410_183203",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6410_183203",
    x1: 478.906,
    y1: 257.99,
    x2: -295.061,
    y2: 55.7042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#144DDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94BFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHeaderMobileScreen);
export default __webpack_public_path__ + "static/media/BG_Header_Mobile_Screen.264ac3d11cc395c9828ee2bd79a1feb7.svg";
export { ForwardRef as ReactComponent };